/* Block styles */
import "./block.scss";

wp.domReady(function () {
    // Nothing to do here
});
